// src/pages/CapturePage/BlockExit.js
//
// How a child screen is left.
//
// No PIN. A block has no exit control while it runs and returns to the examiner
// by itself when it ends; this is the deliberate escape hatch for when it does
// not — a three-second press, no secret. A child who holds it for three seconds
// ends a game, and the examiner starts it again, which costs nothing. What
// matters is where they land: their own session screen, never the dashboard.
import React, { useCallback, useEffect, useRef, useState } from 'react';

const HOLD_MS = 3000;

export default function BlockExit({ onExit, label = 'Hold to stop' }) {
    const [progress, setProgress] = useState(0);
    const timerRef = useRef(null);
    const startedRef = useRef(0);

    const clear = useCallback(() => {
        if (timerRef.current) {
            clearInterval(timerRef.current);
            timerRef.current = null;
        }
        setProgress(0);
    }, []);

    useEffect(() => clear, [clear]);

    const begin = (e) => {
        if (e && e.preventDefault) e.preventDefault();
        if (timerRef.current) return;
        startedRef.current = Date.now();
        timerRef.current = setInterval(() => {
            const held = Date.now() - startedRef.current;
            if (held >= HOLD_MS) {
                clear();
                onExit();
            } else {
                setProgress(held / HOLD_MS);
            }
        }, 50);
    };

    return (
        <button
            type="button"
            className="cap-exit"
            aria-label={label}
            onPointerDown={begin}
            onPointerUp={clear}
            onPointerLeave={clear}
            onPointerCancel={clear}
            onTouchStart={begin}
            onTouchEnd={clear}
            onMouseDown={begin}
            onMouseUp={clear}
        >
            <span className="cap-exit-fill" style={{ width: `${Math.round(progress * 100)}%` }} />
            <span className="cap-exit-label">{progress > 0 ? 'Keep holding…' : label}</span>
        </button>
    );
}
